// escapeHTML: minimaler HTML-Entity-Escaper für String-Interpolation in
// innerHTML/Template-Strings. Generic, tenant-agnostisch.
//
// Escaped die fünf für HTML-Kontexte (Text + doppelt/einfach gequotete
// Attribute) relevanten Zeichen. & MUSS zuerst escaped werden, sonst werden
// die nachfolgend eingefügten Entities doppelt escaped.

const HTML_ESCAPES: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

export function escapeHTML(s: string): string {
  return s.replace(/[&<>"']/g, (c) => HTML_ESCAPES[c] ?? c);
}
